import { Product } from "../classModels";

export const STARTING_PRODUCTS: Product[] = [
  {
    id: "7e0478cc-decc-432b-92e4-6dfc78c25222",
    category: "Men",
    sub_category: "Boy",
    type: "t-shirt",
    price: 499,
    image: {
      id: "c8c4809a-49ee-4df3-ad31-cfe2acc36049",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_1.jpg",
    },
    name: "T-shirt",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 4,
  },
  {
    id: "3a8974bd-d9c9-4605-984a-34c7ac8cbd4e",
    category: "Women",
    sub_category: "Girl",
    type: "top",
    price: 629,
    image: {
      id: "ddec5fce-cce7-41b4-8190-b0b23dfb19f2",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_2.jpg",
    },
    name: "Off-shoulder crop top",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 5,
  },
  {
    id: "58a977e6-18f8-400a-a931-8fa8d183ab11",
    category: "Kids",
    sub_category: "Girl",
    type: "frock",
    price: 779,
    image: {
      id: "fc2f6101-7722-4d46-8ae2-f17b4059004a",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_3.jpg",
    },
    name: "Frock",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 5,
  },
  {
    id: "a948a84c-aeba-4214-9826-236328f5b669",
    category: "Kids",
    sub_category: "Boy",
    type: "t-shirt",
    price: 399,
    image: {
      id: "d1acc6e4-ec0c-46b0-b0b9-6e6f32a67972",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_4.jpg",
    },
    name: "Cotton t-shirt",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 4,
  },
  {
    id: "35609f96-f854-4c21-99f5-14bf35454249",
    category: "Male",
    type: "footwear",
    sub_category: "Boy",
    price: 3099,
    image: {
      id: "c293ee5d-2c88-41a0-bb39-f63de0f8f627",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_5.jpg",
    },
    name: "Leather boots",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 5,
  },
  {
    id: "abfbdcf8-80ab-4242-a6cb-0eeca1d9be11",
    category: "Women",
    type: "bag",
    sub_category: "Girl",
    price: 879,
    image: {
      id: "fbac8c3f-7c11-44bb-a396-9ee16ce270fd",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_6.jpg",
    },
    name: "Handbag",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 5,
  },
  {
    id: "5b564613-b3c0-4e03-bd35-0f85e4c36d33",
    category: "Women",
    type: "shrug",
    sub_category: "Girl",
    price: 599,
    image: {
      id: "47e2677e-8e93-4382-bcb0-da2b93ffbf1a",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_7.jpg",
    },
    name: "Shrug",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 4,
  },
  {
    id: "99af3641-9e7b-4e38-89d9-d01b85168ead",
    category: "Women",
    type: "jeans",
    sub_category: "Girl",
    price: 1049,
    image: {
      id: "4364c666-1a83-4926-a0fc-af637e7ce8a2",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_8.jpg",
    },
    name: "Faded boyfriend jeans",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 4,
  },
  {
    id: "1ae526e0-d84d-48e6-98ca-7a444bfd7b53",
    category: "Women",
    type: "bag",
    sub_category: "Girl",
    price: 589,
    image: {
      id: "e2debc74-127d-4df6-b2b5-1024ae824aa0",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_9.jpg",
    },
    name: "Sling bag",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 4,
  },
  {
    id: "c3e02b05-54ce-46cc-be6b-14777787021f",
    category: "Women",
    type: "footwear shoes",
    sub_category: "Girl",
    price: 2069,
    image: {
      id: "578bae79-9f6d-424f-8214-68be396492b4",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_10.jpg",
    },
    name: "Sneakers",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 5,
  },
  {
    id: "457a76ac-76c7-4f7f-ab84-efecdc358595",
    category: "Men",
    type: "jacket",
    sub_category: "Boy",
    price: 669,
    image: {
      id: "f4c50c9a-7b5e-45be-8106-6f5feaa7b2fa",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_11.jpg",
    },
    name: "Denim jacket",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 2,
  },
  {
    id: "af59833c-df6d-4bbf-b6f2-209aa4999548",
    category: "Women",
    type: "shirt",
    sub_category: "girl",
    price: 869,
    image: {
      id: "5de78f8c-9af6-48c6-a2d2-60b977f23221",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_12.jpg",
    },
    name: "Bottom tied top",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 4,
  },
  {
    id: "93cbcf34-74cc-4679-86e3-5db1bc8b1662",
    category: "Women",
    type: "bag",
    sub_category: "Girl",
    price: 969,
    image: {
      id: "ec44cf1b-f0a2-420e-aad1-b18fa3032c90",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_13.jpg",
    },
    name: "Set of 5 sling bags",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 4,
  },
  {
    id: "87b0160c-8e2f-4e9c-8d99-1910150c7959",
    category: "Kids",
    type: "frock",
    sub_category: "Girl",
    price: 539,
    image: {
      id: "729640ce-7ac8-4ad5-a5c2-87a1de8ed883",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_14.jpg",
    },
    name: "frock",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 3,
  },
  {
    id: "3f3489b1-dc12-4b86-88b0-761edc9125a5",
    category: "Men",
    type: "t-shirt",
    sub_category: "Boy",
    price: 369,
    image: {
      id: "4fa17480-0121-4152-a9d7-bd63643995ad",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_15.jpg",
    },
    name: "T-shirt",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 4,
  },
  {
    id: "e9676c35-aeff-40d6-842c-2a3731a9aaba",
    category: "Men",
    type: "watch",
    sub_category: "Boy",
    price: 1039,
    image: {
      id: "ea12ecc2-b8f4-4938-8f5d-b3a15f77d754",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_16.jpg",
    },
    name: "Black Plastic band watch",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 4,
  },
  {
    id: "4c48cf00-0d89-4982-8651-4c5678b77d95",
    category: "Women",
    type: "dress",
    sub_category: "Girl",
    price: 969,
    image: {
      id: "8c596560-efd8-44f6-93d0-2103e60a5655",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_17.jpg",
    },
    name: "Glittered dress",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 4,
  },
  {
    id: "0bdba796-f521-489f-bfc0-c55045f477fb",
    category: "Women",
    type: "jeans",
    sub_category: "Girl",
    price: 1069,
    image: {
      id: "bbebea5a-38e8-4758-af72-9a5f43b9d66b",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_18.jpg",
    },
    name: "Jeans",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 4,
  },
  {
    id: "da6225b4-2056-4e0d-948c-0d40cc555e83",
    category: "Men",
    type: "jacket",
    sub_category: "Boy",
    price: 4889,
    image: {
      id: "1c790549-fb5b-4765-b33b-214333bdee1c",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_19.jpg",
    },
    name: "Leather jacket",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 4,
  },
  {
    id: "c015699b-6f0b-4b5a-b59e-64f7b72f826b",
    category: "Men",
    type: "footwear shoes",
    sub_category: "Boy",
    price: 1209,
    image: {
      id: "7b922737-9d56-44ae-a38f-5ffc2367d61f",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_20.jpg",
    },
    name: "Traditional shoes",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 5,
  },
  {
    id: "7fc583fd-6b2b-4364-a8c1-1cfff271fa7b",
    category: "Men",
    type: "watch",
    sub_category: "Boy",
    price: 4999,
    image: {
      id: "7f829ed5-37e6-4d7b-8bdd-2a1581ace9d1",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_21.jpg",
    },
    name: "Royal watch",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 5,
  },
  {
    id: "da739ee1-5317-46b5-89ed-cabac2c8ffbd",
    category: "Women",
    type: "shorts",
    sub_category: "Girl",
    price: 569,
    image: {
      id: "043fa603-6914-49f4-b067-62761dd6e9ec",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_22.jpg",
    },
    name: "denim shorts",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 4,
  },
  {
    id: "a937291c-765e-4f69-86c9-d18e7e430ead",
    category: "Men",
    type: "footwear shoes",
    sub_category: "Boy",
    price: 2069,
    image: {
      id: "5bde9700-77bb-480d-b3ba-762571bf7d67",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_23.jpg",
    },
    name: "Boots",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 4,
  },
  {
    id: "0a3506d2-9bf6-427a-bbf9-da7c91064b02",
    category: "Women",
    type: "shorts",
    sub_category: "Girl",
    price: 669,
    image: {
      id: "8ef96255-14fb-476c-b723-47a0f15c842a",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_24.jpg",
    },
    name: "Denim shorts",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 5,
  },
  {
    id: "d321d587-cdf8-4c06-8405-0e5ba1fc3de1",
    category: "Women",
    type: "jeans",
    sub_category: "Girl",
    price: 989,
    image: {
      id: "45713619-c12e-489c-a27c-88fa287b6fd5",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_25.jpg",
    },
    name: "Lightly scratched jeans",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 4,
  },
  {
    id: "29d0d08d-f7fb-4b36-bbb3-461568730d6e",
    category: "Men",
    type: "hoodie",
    sub_category: "Boy",
    price: 789,
    image: {
      id: "b2f0fbc2-1d86-4795-b2af-77d85eee8cb9",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_26.jpg",
    },
    name: "Hoodie",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 4,
  },
  {
    id: "2d2234ef-9294-4f06-86a4-2a6fe35baef4",
    category: "Women",
    type: "footwear sandals",
    sub_category: "Girls",
    price: 2079,
    image: {
      id: "0dcc82ec-c83e-4395-817d-d62ec89a830d",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_27.jpg",
    },
    name: "Sandal block heels",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 5,
  },
  {
    id: "3abc7ae6-4719-493c-9ec8-6237afce7f9b",
    category: "Women",
    type: "footwaer Bellies",
    sub_category: "Girl",
    price: 1099,
    image: {
      id: "d911f450-129a-4257-9d33-866bb3f2a188",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_28.jpg",
    },
    name: "bellies",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 3,
  },
  {
    id: "4ebc5008-e2c4-493b-86a9-84575574c2d7",
    category: "Women",
    type: "footwear sandals",
    sub_category: "Girls",
    price: 2039,
    image: {
      id: "4d673780-2ede-4fd9-bc4a-8eebd830e4c5",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_29.jpg",
    },
    name: "blue sneakers",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 4,
  },
  {
    id: "20b9ab6a-3c1a-4fa6-bd96-007c110149fa",
    category: "Women",
    type: "footwear Bellies",
    sub_category: "Girl",
    price: 5029,
    image: {
      id: "b7803398-8711-44f1-a980-4ecbb313b1b2",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_30.jpg",
    },
    name: "Glittered bellies",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 4.2,
  },
  {
    id: "b22d1b5f-590c-4b79-a769-2bdf062b752b",
    category: "Women",
    type: "co-ords",
    sub_category: "Girls",
    price: 2319,
    image: {
      id: "865282ae-9c70-4bfc-bef9-49810dd002ac",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_31.jpg",
    },
    name: "Co-ords",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 2,
  },
  {
    id: "971de90e-37bc-4bac-b006-bf1d0c9a46ee",
    category: "Men",
    type: "shirt",
    sub_category: "Boys",
    price: 709,
    image: {
      id: "ed015c3f-ce91-4e4d-bec1-aa4ce2b3afae",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_32.jpg",
    },
    name: "Check shirt",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 4,
  },
  {
    id: "84e77327-38ae-4783-88a8-9f08a0e71e37",
    category: "Men",
    type: "shirt",
    sub_category: "Boys",
    price: 879,
    image: {
      id: "a6db02e1-28ed-46da-8d5e-837ec2e9379e",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_33.jpg",
    },
    name: "Shirt",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 4,
  },
  {
    id: "85e5714c-0fcc-46b0-83e9-6ba29258f4fc",
    category: "Men",
    type: "shirt",
    sub_category: "Boys",
    price: 999,
    image: {
      id: "259a1ebb-0410-4bd9-9ed3-63a708cb0728",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_34.jpg",
    },
    name: "Checkered shirt",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 5,
  },
  {
    id: "70ab3d16-62dc-495d-9b0c-818b980bdd40",
    category: "Men",
    type: "shirt",
    sub_category: "Boy",
    price: 959,
    image: {
      id: "0e2f85db-5331-42e7-881d-43464b5ac3ad",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_35.jpg",
    },
    name: "Formal shirt",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 3,
  },
  {
    id: "dd0f2a36-a8ed-4d36-b116-c1b085f409a4",
    category: "Kids",
    type: "top",
    sub_category: "Girls",
    price: 339,
    image: {
      id: "aee1d7d6-d45a-4e39-ae88-1c252f3cbe4a",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_36.jpg",
    },
    name: "Top",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 2,
  },
  {
    id: "4f75d2b3-3a69-4727-9e09-1f6493480856",
    category: "Women",
    type: "trouser",
    sub_category: "Girls",
    price: 819,
    image: {
      id: "6d026793-101a-4d53-9c18-3ec72b99ac3c",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_37.jpg",
    },
    name: "Trouser",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 3,
  },
  {
    id: "496282be-f3c9-4ee3-baef-12804f864611",
    category: "Men",
    type: "t-shirt",
    sub_category: "Boys",
    price: 459,
    image: {
      id: "6fe94542-56e6-4add-aa9c-4c99946ef668",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_38.jpg",
    },
    name: "T-shirt",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 4,
  },
  {
    id: "fbd38162-52cd-4537-ae10-2e2bdaa33c58",
    category: "Men",
    type: "t-shirt",
    sub_category: "Boys",
    price: 449,
    image: {
      id: "0bbb78a8-ea1f-4d32-95e3-02aa269e0358",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_39.jpg",
    },
    name: "Plain t-shirt",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 2,
  },
  {
    id: "255515bf-8534-48d2-8a37-23ca66e00713",
    category: "Women",
    type: "footwear shoes",
    sub_category: "Girls",
    price: 2069,
    image: {
      id: "72a65566-6938-43f4-acea-875939e7cede",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_40.jpg",
    },
    name: "Casual shoes",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 5,
  },
  {
    id: "0bac1741-c1e8-4da6-bd0d-98dcbd58f217",
    category: "Women",
    type: "jeans",
    sub_category: "Girls",
    price: 989,
    image: {
      id: "8a122ac4-ed75-4349-bb6e-3d6f0f5501d8",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_41.jpg",
    },
    name: "Solid jeans",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 3,
  },
  {
    id: "d1150da9-f5cf-47f2-b85a-cc6b5e10c2fc",
    category: "Men",
    type: "watch",
    sub_category: "Boys",
    price: 2099,
    image: {
      id: "daa26b6a-b34a-4d9e-8601-c3191421f85a",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_42.jpg",
    },
    name: "Watch",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 4,
  },
  {
    id: "a9207c66-71f7-4ff2-8394-5c05777ba995",
    category: "Women",
    type: "watch",
    sub_category: "Girls",
    price: 2069,
    image: {
      id: "8ebe2475-e08b-4a35-9941-1d90960b32c9",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_43.jpg",
    },
    name: "Metal watch",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 4,
  },
  {
    id: "0c10e829-2251-4c31-a949-eaa2c76784df",
    category: "Kids",
    type: "dress",
    sub_category: "any",
    price: 2019,
    image: {
      id: "f588d4a8-5fdd-4761-a22a-d1e88e01ccf1",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_44.jpg",
    },
    name: "Furred bodysuit",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 4,
  },
  {
    id: "e7f93819-e5f3-4587-a344-d2cba48cf0b5",
    category: "Men",
    type: "watch",
    sub_category: "Boys",
    price: 7029,
    image: {
      id: "374d7c55-344b-4624-96fa-547e3b8208e7",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_45.jpg",
    },
    name: "Silver metal watch",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 5,
  },
  {
    id: "cbbddfff-2b0c-4a98-b3b5-510b082c64f2",
    category: "Men",
    type: "watch",
    sub_category: "Boys",
    price: 3069,
    image: {
      id: "fa305c51-1082-4228-a89b-975b7ba43edb",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_46.jpg",
    },
    name: "blue metal watch",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 4,
  },
  {
    id: "9c955e25-c10f-4f07-adf2-00df17d515ae",
    category: "Kids",
    type: "dress",
    sub_category: "any",
    price: 999,
    image: {
      id: "cd89c9ee-e594-454d-b037-88eef69fe450",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_47.jpg",
    },
    name: "fully covering bodysuit",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 4,
  },
  {
    id: "48366b7f-857d-49d5-a6dc-c89c2291d7bc",
    category: "Men",
    type: "hoodie",
    sub_category: "Boys",
    price: 919,
    image: {
      id: "2e70de43-ca64-4e1c-9525-2cd7be26305e",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_48.jpg",
    },
    name: "Check hoodie",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 4,
  },
  {
    id: "d107fa69-1ad3-424e-b596-123660e9fb7d",
    category: "Men",
    type: "footwear shoes",
    sub_category: "Boys",
    price: 5099,
    image: {
      id: "b30a32b4-1205-4bce-8692-db38b3b2a1d4",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_49.jpg",
    },
    name: "Fox leather boots",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 5,
  },
  {
    id: "b2dbf07b-5e3c-458c-8f41-ac66d2ff858b",
    category: "Women",
    type: "jumpsuit",
    sub_category: "Grils",
    price: 1029,
    image: {
      id: "62b49c72-88b9-4a10-a9c3-2bf37780daad",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_50.jpg",
    },
    name: "Jump suit with belt",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 5,
  },
  {
    id: "34ff88f1-94ae-4eec-8085-15f935a49f42",
    category: "Women",
    type: "footwear bellies",
    sub_category: "Girls",
    price: 2039,
    image: {
      id: "b029f6df-0f34-453a-aadb-d750e420f55f",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_51.jpg",
    },
    name: "White bellies",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 4,
  },
  {
    id: "0e1e6f3c-23a5-46c7-a7ff-619fc04d606e",
    category: "Women",
    type: "footwear bellies",
    sub_category: "Girls",
    price: 2019,
    image: {
      id: "6c916d3e-ee22-42e8-94d2-ec9ea167ac61",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_52.jpg",
    },
    name: "Flower print bellies",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 4,
  },
  {
    id: "3fe29f2e-5341-4b50-8859-7b6392e6eef5",
    category: "Men",
    type: "footwear shoes",
    sub_category: "Boys",
    price: 769,
    image: {
      id: "60c66ce7-9e7a-47e0-bde4-e22ab947f7a9",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_53.jpg",
    },
    name: "Multi color sneakers",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 5,
  },
  {
    id: "374cc196-6dc6-4973-86cb-ee5a039ca0f1",
    category: "Men",
    type: "jeans",
    sub_category: "Boys",
    price: 969,
    image: {
      id: "adec3d11-04b8-4f75-9d5c-e9dce95a0d53",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_54.jpg",
    },
    name: "Solid jeans",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 2,
  },
  {
    id: "e07e5cd8-c2ad-46ba-af3d-1db5ec077869",
    category: "Men",
    type: "pants",
    sub_category: "Boys",
    price: 869,
    image: {
      id: "6472fc5e-607f-4e94-892f-c2077e0f3834",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_55.jpg",
    },
    name: "Casual pants",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 4,
  },
  {
    id: "efe94417-a615-4365-82d1-e1b9681c53d0",
    category: "Kids",
    type: "frock",
    sub_category: "Girls",
    price: 999,
    image: {
      id: "efe2fedf-b10c-45e5-acb8-501cafd477b9",
      url: "https://fabshop-images.s3.ap-south-1.amazonaws.com/fabshop+images/img_56.jpg",
    },
    name: "Wooven frock",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque blandit mauris commodo arcu molestie, in imperdiet sapien sagittis. Donec pharetra in orci eu convallis. Ut eu imperdiet nisi, eu consectetur nisi. Sed et molestie tortor. Pellentesque gravida quam nec neque commodo pharetra non vitae mauris. Cras fermentum leo quis dapibus dictum. Duis non elit turpis. Fusce et nulla id mauris vestibulum efficitur quis eu odio.",
    ratings: 4,
  },
];
